"use strict";

exports.__esModule = true;
exports.default = void 0;

var _table = require("./table");

var _plugins = require("../../utils/plugins");

var components = {
  BTable: _table.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/table/index.js
// module id = 518
// module chunks = 0